import React from 'react';
import logo from './logo.svg';
// import {Counter} from './features/counter/Counter';
import './App.css';
import Header from "./components/Header"
import Head from "./components/Head"

function App() {
  return (
    <div className="App">
      <Head/>
   <Header/>
   
    </div>
  );
}
export default App;
